import React from 'react';
import * as _ from "lodash";
import {getData} from "../utils/api"
import {Link} from 'react-router-dom';
import {connect} from 'react-redux'
import {getCompanies} from "../redux/actions/companies"
import {CompanyData} from '../utils/api';

interface HomeProps {
  companies: CompanyData[];
  getCompanies: typeof getCompanies;
}

class Home extends React.Component < HomeProps, {} > {
  cardStates = ["In Progress", "", "Action Taken"];
  constructor(props) {
    super(props);
    this.state = {
      stateIndex: null,
      cards: [],
      filteredCards: [],
      loading: true,
      error: false
    };
  }
  componentWillMount() {
    var cards = []
    let that = this;
    const {filterCards} = this;
    const {stateIndex} = this.state;
    const {companies, getCompanies} = this.props;
    getData((cards) => {
      if (cards == null) {
        return that.setState({cards: [], loading: false})
      }
      that.setState({
        cards,
        loading: false
      }, () => {
        filterCards(stateIndex)
      })
    }, () => {
      that.setState({loading: false, error: true})
    });

    if (companies == null) {
      getCompanies()
    }

  }
  filterCards = (stateIndex) => {
    const {cards} = this.state;
    this.setState({stateIndex})
    if (stateIndex == null) {
      this.setState({filteredCards: cards})
    } else {
      let filteredCards = _.filter(cards, (c) => {
        return c.state == stateIndex;
      });
      this.setState({filteredCards})
    }
  }
  render() {
    const {companies} = this.props;
    const {filterCards, cardStates} = this;
    const {stateIndex} = this.state
    if (this.state.loading) {
      return (<div className={"container banner center"}>
        <img alt="pink-bg" className={"pink-bg"} src={"https://static.perpetua.io/perpetuaio_2/img/pink-bg.svg"}/>
        <img alt="blue-bg" className={"blue-bg"} src={"https://static.perpetua.io/perpetuaio_2/img/blue-bg.svg"}/>
        <div className="informational">
          <img alt="spinner" className="spin" src="/loading.png"/>
          <h4>Retrieving HIT cards</h4>
        </div>
      </div>);
    } else if (this.state.error) {
      return (<div className={"container banner center"}>
        <img alt="pink-bg" className={"pink-bg"} src={"https://static.perpetua.io/perpetuaio_2/img/pink-bg.svg"}/>
        <img alt="blue-bg" className={"blue-bg"} src={"https://static.perpetua.io/perpetuaio_2/img/blue-bg.svg"}/>
        <div className="informational">
          <img alt="error" src="/error.png"/>
          <h4>Could Not Retrieve HIT cards</h4>
        </div>
      </div>);
    } else if (this.state.cards.length > 0) {
      return (< div className = {
        "container banner"
      } > <img alt="pink-bg" className={"pink-bg"} src={"https://static.perpetua.io/perpetuaio_2/img/pink-bg.svg"}/>
      <img alt="blue-bg" className={"blue-bg"} src={"https://static.perpetua.io/perpetuaio_2/img/blue-bg.svg"}/>
      <ul className="stateFilter">
        <a className={"btn white deep-purple-text" + (
            stateIndex == null
            ? " active"
            : " ")} onClick={() => filterCards(null)}>All</a>
        {
          _.map(cardStates, (label, index) => {
            if (index == 1) {
              return
            }
            let activeClass = (
              stateIndex == index
              ? " active"
              : " ")
            return <a key={index} className={"btn white deep-purple-text" + activeClass} onClick={() => filterCards(index)}>{label}</a>;
          })
        }
      </ul> < div className = {
        "row banner-row"
      } > {
        _.map(this.state.filteredCards, (card, i) => {
          let companyName = null;
          if (companies != null) {
            let company = _.find(companies, (c) => {
              return c.id == card.companyId
            })
            companyName = company
              ? company.name
              : null;
          }
          return <div className={"HIT-card-item"} key={i}>
            <div className={"HIT-card"}>
              <div className={"content"}>
                {
                  card.headerImage.url && <div className={"main-image"} style={{
                        backgroundImage: `url(${card.headerImage.url})`
                      }}/>
                }
                {
                  (card.previewBanner.iconUrl.url || card.previewBanner.text.text) && <div className={"product-preview"}>
                      {
                        card.previewBanner.iconUrl.url && <div className={"img-holder"}>
                            <img alt={"img"} className={"image"} src={card.previewBanner.iconUrl.url}/>
                          </div>
                      }
                      {card.previewBanner.text.text && <div className={"title"}>{card.previewBanner.text.text}</div>}
                    </div>
                }
                <div className="text-content">
                  <p className={"main-title"}>{card.title.text}</p>
                  <p className={"sub-title"}>{card.subtitle.text}</p>
                </div>
              </div>
              <div className={"metrics"}>
                {
                  _.map(card.rows, (row, row_i) => {
                    return <div key={row_i} className="master-metric-holder">
                      <p className="met-main-title">{row.title.text}</p>
                      <div className="met-row">
                        {
                          _.map(row.columns, (column, column_i) => {
                            return <div key={column_i} className="met-col">
                              <span className="met-title">{column.name.text}</span>
                              <span className="met-number" style={{
                                  color: column.value.color.hex
                                }}>{column.value.text}</span>
                            </div>
                          })

                        }
                      </div>
                    </div>
                  })
                }
              </div>
              <div className={"actions"}>
                {
                  _.map(card.actions, (a, a_I) => {
                    return <a key={a_I} style={{
                        color: a.text.color.hex
                      }}>{a.text.text}</a>
                  })
                }
              </div>
            </div>
            <div>
              {
                (card.userEmail) && <div>
                    <span className="bold">Delivered to:
                    </span>
                    <span>
                      {card.userEmail}</span>
                  </div>
              }
              {
                companyName
                  ? <div>
                      <span className="bold">Company:
                      </span>
                      <span>
                        {companyName}</span>
                    </div>
                  : (card.companyId) && <div>
                      <span className="bold">Company ID:
                      </span>
                      <span>
                        {card.companyId}</span>
                    </div>
              }
              <div>
                <span className="bold">State:</span>
                <span>{cardStates[card.state]}</span>
              </div>
              {
                card.actionTaken && <div>
                    <span className="bold">Action Taken:</span>
                    <span>{card.actionTaken.text.text}</span>
                  </div>
              }
            </div>
          </div>;
        })
      } < /div>
    </div >);
    } else {
      return (<div className={"container banner center"}>
        <img alt="pink-bg" className={"pink-bg"} src={"https://static.perpetua.io/perpetuaio_2/img/pink-bg.svg"}/>
        <img alt="blue-bg" className={"blue-bg"} src={"https://static.perpetua.io/perpetuaio_2/img/blue-bg.svg"}/>
        <div className="informational">
          <h4>There are no HIT cards</h4>
          <p>
            <Link to={'/create'} className={'deep-purple-text lighten-1 bold'}>Create Card</Link>
          </p>
        </div>
      </div>);
    }
  }
}

const mapStateToProps = state => ({companies: state.companies.companies})
export default connect(mapStateToProps, {getCompanies})(Home)



// WEBPACK FOOTER //
// ./src/Component/Home.js